module.exports = __webpack_public_path__ + "assets/fb4aadfe4148f75e7cecf1afa9db19f9.png";